<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { colProps } from './col'

defineOptions({
  name: 'VsCol',
})

const props = defineProps(colProps)

// init here
</script>
